<div class="col-lg-3 mx-auto" (ngSubmit)="tokenizer.submit()">
    <div class="row g-0 my-1">
        <h1 class="text-center">Checkout</h1>
    </div>
    <form id="card-form" class="col mx-auto" [formGroup]="cardForm" (ngSubmit)="tokenizer.submit()">
        
        <div class="row g-0 my-1">
            <h2 class="text-start">Billing Information</h2>
        </div>
        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="First Name" formControlName="firstName">
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="Last Name" formControlName="lastName">
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="Address Line 1" formControlName="addressLine1">
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="Address Line 2" formControlName="addressLine2">
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="City" formControlName="city">
        </div>

        <div class="row g-0 my-1">
            <div class="col">
            <input type="text" class="form-control rounded-end-0" placeholder="State" formControlName="state" [ngStyle]="{'pointer-events':'none'}" readonly>
            </div>
            <div ngbDropdown class="col d-flex">
                <button type="button" class="flex-grow-1 btn btn-primary rounded-start-0" id="dropdownBasic1" ngbDropdownToggle>
                    Select State
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    @for (state of states; track $index) {
                    <button ngbDropdownItem type="button" (click)="selectState(state)">{{ state.name }} | {{ state.code }}</button>
                    }
                </div>
            </div>
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="Zip Code" formControlName="zip">
        </div>

        <div class="row g-0 my-1">
            <div class="col">
            <input 
                placeholder="yy/mm/dd" 
                class="form-control rounded-end-0" 
                ngbDatepicker #d="ngbDatepicker" 
                [maxDate]="maxDate"
                [minDate]="minDate"
                [ngStyle]="{'pointer-events':'none'}"
                formControlName="dateOfBirth"
                readonly
            >
            </div>
            <div class="col d-flex">
                <button class="btn btn-primary bi bi-calendar3 rounded-start-0 flex-grow-1" (click)="d.toggle()" type="button">Select Date of Birth</button>
            </div>
        </div>

        <div class="row g-0 my-1">
            <input type="email" placeholder="john.doe@email.com" class="form-control" formControlName="email">
        </div>

        <div class="row g-0 my-1">
            <input type="tel" formControlName="phoneNumber" placeholder="Phone Number" class="form-control">
        </div>

        <div class="row g-0 my-1">
            <div id="checkout-form" class="flex-grow-1"></div>
        </div>

        <div class="row g-0 my-1">
            <h2 class="text-start">Shipping Information</h2>
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="Address Line 1" formControlName="shippingAddressLine1">
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="Address Line 2" formControlName="shippingAddressLine2">
        </div>

        <div class="row g-0 my-1">
            <input type="text" class="form-control" placeholder="City" formControlName="shippingCity">
        </div>

        <div class="row g-0 my-1">
            <div class="col">
            <input type="text" class="form-control rounded-end-0" placeholder="State" formControlName="shippingState" [ngStyle]="{'pointer-events':'none'}" readonly>
            </div>
            <div ngbDropdown class="col d-flex">
                <button type="button" class="flex-grow-1 btn btn-primary rounded-start-0" id="dropdownBasic1" ngbDropdownToggle>
                    Select State
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    @for (state of states; track $index) {
                    <button ngbDropdownItem type="button" (click)="selectShippingState(state)">{{ state.name }} | {{ state.code }}</button>
                    }
                </div>
            </div>
        </div>

        <div class="row g-0 my-1">
            <input type="text" maxlength="5" class="form-control" placeholder="Zip Code" formControlName="shippingZip" (ngModelChange)="onZipChange()">
        </div>

        <div class="row g-0 my-1" *ngIf="estimatedShipping != undefined">
            <h2 class="text-start">Estimated Shipping: {{estimatedShipping.toFixed(2)}}</h2>
        </div>
        <div class="row g-0 my-1">
            <button class="btn btn-primary" id="card-button" type="submit" [disabled]="!cardForm.valid">Pay ${{getTotal()}}</button>
        </div>
    </form>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
